<template>
  <div class="ruller-form-control">
    <div class="ruller-prop-control-section">
      <label
        :for="instanceId + 'wallColor'"
        class="ruller-prop-control-section-header"
        >Цвет стены</label
      >
      <div class="ruller-prop-control-section-row">
        <div
          class="ruller-prop-control-input-wrapper ruller-prop-control-input-wrapper-color"
        >
          <input
            type="color"
            v-model="wallColorModel"
            :id="instanceId + 'wallColor'"
            @keyup.enter="blurInputWhenClickEnter"
          />
        </div>
      </div>

      <label
        :for="instanceId + 'wallWidth'"
        class="ruller-prop-control-section-header"
        >Толщина стены</label
      >
      <div class="ruller-prop-control-section-row">
        <div
          class="ruller-prop-control-section-row-split ruller-prop-control-section-row-split-75"
        >
          <div class="ruller-prop-control-input-wrapper">
            <input
              type="number"
              v-model="wallWidthModel"
              :id="instanceId + 'wallWidth'"
              @keyup.enter="blurInputWhenClickEnter"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="ruller-prop-control-section-header">Нарисованные стены:</div>
      <div v-if="walls.length === 0">
        <div class="walls-empty">Начните рисовать</div>
      </div>
      <div
        v-for="wall in walls"
        :key="JSON.stringify(wall.points)"
      >
        <wall-item
          :wall="wall"
          :walls="walls"
          @remove-wall="handleRemoveWall"
          @select-wall="handleSelectWall"
          @hover-wall="handleHoverWall"
          @update-wall-name="handleUpdateWallName"
        />
        <!-- <div>{{ wall }}</div> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.walls-empty {
  padding: 4px 10px;
}

.ruller-form-control {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;
  .ruller-prop-control-section {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 12px;
    padding-bottom: 1em;
    border-bottom: 1px solid silver;
  }
  .ruller-prop-control-section-header {
    box-sizing: border-box;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 0.5em;
    padding-left: 0.25em;
  }
  .ruller-prop-control-section-row {
    box-sizing: border-box;
    padding: 0 0.25em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    .ruller-prop-control-section-row-split {
      box-sizing: border-box;
      overflow: hidden;
      &.ruller-prop-control-section-row-split-5 {
        width: 5%;
        max-width: 5%;
        min-width: 5%;
      }
      &.ruller-prop-control-section-row-split-10 {
        width: 10%;
        max-width: 10%;
        min-width: 10%;
      }
      &.ruller-prop-control-section-row-split-15 {
        width: 15%;
        max-width: 15%;
        min-width: 15%;
      }
      &.ruller-prop-control-section-row-split-20 {
        width: 20%;
        max-width: 20%;
        min-width: 20%;
      }
      &.ruller-prop-control-section-row-split-25 {
        width: 25%;
        max-width: 25%;
        min-width: 25%;
      }
      &.ruller-prop-control-section-row-split-30 {
        width: 30%;
        max-width: 30%;
        min-width: 30%;
      }
      &.ruller-prop-control-section-row-split-33 {
        width: 33.33333%;
        max-width: 33.33333%;
        min-width: 33.33333%;
      }
      &.ruller-prop-control-section-row-split-35 {
        width: 35%;
        max-width: 35%;
        min-width: 35%;
      }
      &.ruller-prop-control-section-row-split-40 {
        width: 40%;
        max-width: 40%;
        min-width: 40%;
      }
      &.ruller-prop-control-section-row-split-45 {
        width: 45%;
        max-width: 45%;
        min-width: 45%;
      }
      &.ruller-prop-control-section-row-split-50 {
        width: 50%;
        max-width: 50%;
        min-width: 50%;
      }
      &.ruller-prop-control-section-row-split-55 {
        width: 55%;
        max-width: 55%;
        min-width: 55%;
      }
      &.ruller-prop-control-section-row-split-60 {
        width: 60%;
        max-width: 60%;
        min-width: 60%;
      }
      &.ruller-prop-control-section-row-split-65 {
        width: 65%;
        max-width: 65%;
        min-width: 65%;
      }
      &.ruller-prop-control-section-row-split-66 {
        width: 66.66666%;
        max-width: 66.66666%;
        min-width: 66.66666%;
      }
      &.ruller-prop-control-section-row-split-70 {
        width: 70%;
        max-width: 70%;
        min-width: 70%;
      }
      &.ruller-prop-control-section-row-split-75 {
        width: 75%;
        max-width: 75%;
        min-width: 75%;
      }
      &.ruller-prop-control-section-row-split-80 {
        width: 80%;
        max-width: 80%;
        min-width: 80%;
      }
      &.ruller-prop-control-section-row-split-85 {
        width: 85%;
        max-width: 85%;
        min-width: 85%;
      }
      &.ruller-prop-control-section-row-split-90 {
        width: 90%;
        max-width: 90%;
        min-width: 90%;
      }
      &.ruller-prop-control-section-row-split-95 {
        width: 95%;
        max-width: 95%;
        min-width: 95%;
      }
      &.ruller-prop-control-section-row-split-100 {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
      }
    }
    &.ruller-prop-margin-top-05 {
      margin-top: 0.5em;
    }
  }
  .ruller-prop-control-select-wrapper {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid silver;
    position: relative;
    height: 2em;
    &:after {
      content: '\25bc';
      width: 1em;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      color: dimgray;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
    select {
      margin: 0;
      padding: 0 0.25em;
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
      cursor: pointer;
      background: transparent;
      background: rgba(0, 0, 0, 0);
      appearance: none;
      font-size: 14px;
    }
    &.ruller-prop-control-select-wrapper-no-left-border {
      border-left: none;
    }
  }
  .ruller-prop-control-input-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 2em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    input[type='text'],
    input[type='number'] {
      width: 100%;
      box-sizing: border-box;
      height: 100%;
      font-size: inherit;
      box-shadow: none;
      outline: none;
      padding: 0 0.25em;
      margin: 0;
      border: 1px solid silver;
      text-align: right;
      &:focus {
        box-shadow: none;
        outline: none;
      }
    }

    label {
      width: 2em;
      height: 100%;
      min-width: 2em;
      max-width: 2em;
      border: 1px solid silver;
      border-right: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: inherit;
      box-sizing: border-box;
    }

    .ruller-prop-control-do-calibrate {
      box-sizing: border-box;
      width: 2em;
      height: 100%;
      overflow: hidden;
      min-width: 2em;
      max-width: 2em;
      border: 1px solid silver;
      border-left: none;
      padding: 0.4em;
      cursor: pointer;
      svg {
        width: 100%;
        height: 100%;
        fill: crimson;
        pointer-events: none;
      }
    }
    &.ruller-prop-control-input-wrapper-color {
      input[type='color'] {
        box-sizing: border-box;
        width: 24%;
        min-width: 25%;
        max-width: 25%;
        margin: 0;
        padding: 0;
        outline: none;
        border: 1px solid silver;
        border-radius: 0;
        height: 100%;
        border-right: none;
        cursor: pointer;
      }
    }
  }
  .ruller-prop-calibration-dimension-divider {
    height: 1.5em;
  }
  .ruller-prop-calibration-row {
    width: 100%;
    .ruller-prop-calibration-equal-sign {
      text-align: center;
      font-weight: bold;
      user-select: none;
    }

    .ruller-prop-calibration-row-l1 {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      height: 2em;
      width: 100%;
      label {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-weight: bold;
        font-family: inherit;
        border: 1px solid silver;
        &:nth-child(1) {
          min-width: 2em;
          width: 2em;
          border-right: none;
          max-width: 2em;
        }
        &:nth-last-child(1) {
          width: 2.5em;
          max-width: 2.5em;
          min-width: 2.5em;
          border-left: none;
        }
      }
      input[type='text'] {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 1px solid silver;
        box-shadow: none;
        border-radius: 0;
        outline: none;
        margin: 0;
        padding: 0 0.25em;
        text-align: right;
      }
    }
    .ruller-prop-calibration-row-l2 {
      box-sizing: border-box;
      width: 100%;
      height: 2em;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      input[type='text'] {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0 0.25em;
        border: 1px solid silver;
        outline: none;
        box-shadow: none;
        border-radius: 0;
        text-align: right;
      }
      .ruller-prop-control-select-wrapper {
        border-left: none;
        width: 25%;
        min-width: 25%;
      }
      .ruller-prop-control-do-calibrate {
        box-sizing: border-box;
        width: 2em;
        height: 100%;
        min-width: 2em;
        max-width: 2em;
        overflow: hidden;
        cursor: pointer;
        border: 1px solid silver;
        border-left: none;
        padding: 0.3em;
        user-select: none;
        svg {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          stroke: black;
          pointer-events: none;
        }
      }
    }
  }
}

.ruller-prop-control-checkbox {
  box-sizing: border-box;
  padding: 0.25em 0;
  input[type='checkbox'] {
    display: none;
    & + label {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      &:before {
        content: '';
        display: block;
        box-sizing: border-box;
        width: 1.25em;
        min-height: 1.25em;
        height: 1.25em;
        max-width: 1.25em;
        outline: 1px solid #00acc8;
        margin-right: 0.5em;
        outline-offset: 0;
      }
    }
    &:checked {
      & + label {
        &:before {
          border: 1px solid white;
          background: #00acc8;
        }
      }
    }
  }
}
</style>
<script>
import { central_data } from '@/lib/vendor/eve/planhub/lib-central-data'
import events from '@/lib/vendor/eve/planhub/lib-events'
import WallItem from './wallItem.vue'

export default {
  name: 'wall-control',
  data: function () {
    return {
      wallColor: '#000000',
      wallWidth: 2,
      walls: [],
      selectedWall: null,
    }
  },
  computed: {
    wallColorModel: {
      get() {
        return this.selectedWall ? this.selectedWall.color : this.wallColor
      },
      set(value) {
        if (value < 1) {
          value = 1
        }
        if (this.selectedWall) {
          this.selectedWall.color = value
        } else {
          this.wallColor = value
        }
      },
    },
    wallWidthModel: {
      get() {
        return this.selectedWall ? this.selectedWall.width : this.wallWidth
      },
      set(value) {
        if (this.selectedWall) {
          this.selectedWall.width = value
        } else {
          this.wallWidth = value
        }
      },
    },
  },
  components: {
    WallItem,
  },
  props: {},
  methods: {
    handleUpdateWallName(wallId, name) {
      this.walls = this.walls.map(w => (w.id === wallId ? { ...w, name } : w))
    },
    handleSelectWall(wallId, state) {
      this.walls = this.walls.map(w =>
        w.id === wallId
          ? { ...w, selected: state }
          : { ...w, selected: false },
      )
    },
    handleHoverWall(wallId, hovered) {
      this.walls = this.walls.map(w =>
        w.id === wallId ? { ...w, hovered } : w,
      )
    },
    handleRemoveWall(wallId) {
      this.walls = this.walls.filter(w => w.id !== wallId)
    },
    updateWallData: function (wallData) {
      if (wallData) {
        const walls = wallData.walls
        const wallColor = wallData.wallColor
        const wallWidth = wallData.wallWidth

        if (wallColor) {
          this.wallColor = wallColor
        }

        if (wallWidth) {
          this.wallWidth = wallWidth
        }

        if (walls) {
          this.walls = walls

          const selectedWall = this.walls.find(w => w.selected)

          if (selectedWall) {
            this.selectedWall = selectedWall
          } else {
            this.selectedWall = null
          }
        }

        this.$forceUpdate()
      }
    },
    updateCustomData: function (wallData) {
      if (wallData) {
        const walls = wallData.walls
        const wallColor = wallData.wallColor
        const wallWidth = wallData.wallWidth

        if (!this.getCustomDataLayer()) {
          return
        }

        if (wallColor) {
          this.getCustomDataLayer().wallColor = wallColor
        }

        if (wallWidth) {
          this.getCustomDataLayer().wallWidth = wallWidth
        }

        if (walls) {
          this.getCustomDataLayer().walls = walls.map(wall => ({
            ...wall,
            selected: false,
          }))
        }
      }
    },
    getCustomDataLayer: function () {
      const customData = central_data().project.custom_data

      if (!customData) {
        return null
      }

      if (!customData.wall) {
        customData.wall = {}
      }

      const timeGenerated = new Date().getTime()
      customData['__@@generated'] = timeGenerated

      return customData.wall
    },
    blurInputWhenClickEnter(event) {
      event.target.blur()
    },
  },
  watch: {
    walls: {
      handler: function () {
        this.updateCustomData({ walls: this.walls })
        central_data().lem.run(events._WALL_GET_WALLS_FROM_PROJECT, this.walls)
      },
      deep: true,
    },
    wallColor: function (n, o) {
      if (n !== o) {
        this.updateCustomData({ wallColor: this.wallColor })
        central_data().lem.run(events._WALL_PREFERENCES_CHANGED, {
          wallColor: this.wallColor,
        })
      }
    },
    wallWidth: function (n, o) {
      if (n !== o) {
        this.updateCustomData({ wallWidth: this.wallWidth })
        central_data().lem.run(events._WALL_PREFERENCES_CHANGED, {
          wallWidth: this.wallWidth,
        })
      }
    },
  },
  created: function () {},
  mounted: function () {
    const setData = () => {
      const wallData = central_data().project.custom_data.wall
      if (wallData) {
        const walls = wallData.walls
        const wallColor = wallData.wallColor
        const wallWidth = wallData.wallWidth

        if (wallColor) {
          this.wallColor = wallColor
          central_data().lem.run(events._WALL_PREFERENCES_CHANGED, {
            wallColor,
          })
        }

        if (wallWidth) {
          this.wallWidth = wallWidth
          central_data().lem.run(events._WALL_PREFERENCES_CHANGED, {
            wallWidth,
          })
        }

        if (walls) {
          this.walls = walls
          central_data().lem.run(
            events._WALL_GET_WALLS_FROM_PROJECT,
            this.walls,
          )
        }
      }
    }

    central_data().on(events._PROJECT_LOAD_COMPLETE, this, function () {
      setData()
    })

    if (central_data().project) {
      setData()
    }

    // Обновление списка стен при изменении данных
    central_data().on(events._WALL_UPDATE_DATA, this, (_, wallData) => {
      this.updateWallData(wallData)
      this.updateCustomData(wallData)
    })

    // Обновлине списка стен при горячей перезагрузке
    central_data().on(events._WALL_GET_DATA_HOT_RELOAD, this, () => {
      central_data().lem.run(events._WALL_GET_WALLS_FROM_PROJECT, this.walls)
      central_data().lem.run(events._WALL_PREFERENCES_CHANGED, {
        wallColor: this.wallColor,
        wallWidth: this.wallWidth,
      })
    })
  },
}
</script>
